import dateFns from 'date-fns'

export default
{
    name: 'app-counter',

    props:
    {
        date: { type: Number }
    },

    data()
    {
        return {
            diff: [0, 0, 0, 0]
        }
    },

    created()
    {
        this.updateCounter()

        this.updateInterval = window.setInterval(() =>
        {
            this.updateCounter()
        }, 1000)
    },

    destroyed()
    {
        window.clearInterval(this.updateInterval)
    },

    methods:
    {
        updateCounter()
        {
            const now = Math.round(Date.now() / 1000)
            let date = this.date // 2 sept 12:39

            if (now > date)
            {
                date = now
            }

            const secToDays = 60 * 60 * 24
            const secToHours = 60 * 60

            const daysDiff = Math.floor((date - now) / secToDays)
            const hoursDiff = Math.floor((date - daysDiff * secToDays - now) / secToHours)
            const minutesDiff = Math.floor((date - daysDiff * secToDays - hoursDiff * secToHours - now) / 60)
            const secondsDiff = Math.floor((date - daysDiff * secToDays - hoursDiff * secToHours - minutesDiff * 60 - now))

            this.diff = [
                this._min2char(daysDiff),
                this._min2char(hoursDiff),
                this._min2char(minutesDiff),
                this._min2char(secondsDiff)
            ]
        },

        _min2char(char)
        {
            return char.toString().length < 2 ? ('0' + char) : char
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-counter/script.js